import { Route, Routes } from 'react-router-dom'

import {
  CloseCircle,
  CloseCircleDetail,
  CloseCircleForm,
} from 'app/routes/pages'
import { RoutingPaths } from 'app/routes/routes'

export const CloseCircleRouter = () => {
  return (
    <Routes>
      <Route
        path={RoutingPaths.closeCircle.start()}
        element={<CloseCircle />}
      />

      <Route
        path={RoutingPaths.closeCircle.form.base()}
        element={<CloseCircleForm />}
      />

      <Route
        path={RoutingPaths.closeCircle.detailFormDetail.base()}
        element={<CloseCircleForm />}
      />

      <Route
        path={RoutingPaths.closeCircle.detailCloseCircle.base()}
        element={<CloseCircleDetail />}
      />
    </Routes>
  )
}
